import { FaMobileAlt, FaClock, FaShieldAlt, FaDollarSign } from 'react-icons/fa';

const features = [
    { 
        id: 1,
        icon: <FaMobileAlt />, // Mobile icon for Easy Booking
        title: 'Easy Booking',
        description: 'Book your ride instantly through our user-friendly mobile app or website.',
    },
    {
        id: 2,
        icon: <FaClock />, // Clock icon for 24/7 Availability
        title: '24/7 Availability',
        description: 'Our taxi services are available around the clock to cater to your travel needs.',
    },
    {
        id: 3,
        icon: <FaShieldAlt />, // Shield icon for Safe Rides
        title: 'Safe Rides',
        description: 'Experience safe and secure rides with our well-maintained vehicles and experienced drivers.',
    },
    {
        id: 4,
        icon: <FaDollarSign />, // Dollar sign icon for Affordable Pricing
        title: 'Affordable Pricing',
        description: 'Enjoy competitive and transparent pricing for all your rides with no hidden charges.',
    },
];

export default features;